// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"1193fcc5","44":"d9b29d63","53":"f455c372","193":"12b5418f","249":"38396449","264":"07f20df6","429":"2d95ed44","453":"38222144","471":"38396449","532":"7d9c5fd4","536":"9a5a0959","867":"a95ebaaa","931":"dc32cb31"}[chunkId] + ".chunk.css";
};